<mat-form-field appearance="fill">
    <mat-date-range-input [rangePicker]="picker"  >
        <input matStartDate readonly [placeholder]=" startPlaceholder | translate" [(ngModel)]="start" (dateChange)="updateValue()" (click)="picker.open()">
        <input matEndDate readonly [placeholder]=" endPlaceholder | translate" [(ngModel)]="end" (dateChange)="updateValue()" (click)="picker.open()">
    </mat-date-range-input>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
<button type="button" *ngIf="displayFilterAction" [disabled]="!filterEnabled" (click)="filter()"><mat-icon>search</mat-icon></button>
<button type="button" *ngIf="displayResetAction" (click)="reset(true)"><mat-icon>loop</mat-icon></button>
